export default __webpack_public_path__ + "static/media/125.8de63796.png";